import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone;

export function InstallButton() {
  const [prompt, setPrompt] = useState(null);
  const [help, setHelp] = useState(false);
  const [installed, setInstalled] = useState(isStandalone());

  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      setPrompt(e);
    };
    const onInstalled = () => setInstalled(true);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed) return null;
  const onClick = async () => {
    if (prompt) {
      prompt.prompt();
      await prompt.userChoice;
      setPrompt(null);
    } else setHelp(true);
  };
  return (
    <>
      <button onClick={onClick} className="inline-flex items-center gap-1.5 rounded-xl border border-[#1A9AA8]/40 text-[#147C88] px-3 py-2 text-xs sm:text-sm font-semibold hover:bg-[#1A9AA8]/10 transition-colors" data-testid="nav-pwa-install-btn">
        <Download className="h-4 w-4" /> <span className="whitespace-nowrap">Install</span>
      </button>
      <Dialog open={help} onOpenChange={setHelp}>
        <DialogContent data-testid="install-help-dialog">
          <DialogHeader>
            <DialogTitle className="font-display">Save Digital Nomad Nicaragua to your Home Screen</DialogTitle>
            <DialogDescription>Open your course like an app and receive alerts.</DialogDescription>
          </DialogHeader>
          <ul className="text-sm space-y-3 text-slate-700">
            <li><strong>iPhone / iPad (Safari):</strong> tap the Share icon, then "Add to Home Screen". Open the app from your Home Screen to enable push alerts.</li>
            <li><strong>Android (Chrome):</strong> tap the menu (three dots), then "Install app" or "Add to Home screen".</li>
            <li><strong>Desktop (Chrome / Edge):</strong> click the install icon in the address bar.</li>
          </ul>
        </DialogContent>
      </Dialog>
    </>
  );
}
